import {APP_INITIALIZER, Injector, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SpinnerConfig } from './constants/spinner_config.cnst';
import { MobileFirstModule } from './modules/mobile-first/mobile-first.module';
import { MaterialModule } from './modules/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectCoreModule } from './modules/project-core/project-core.module';
import { VlHttpService, ENV_CONFIG, AppPermissionsPipe } from 'shared-library';
import { DragDropModule,CdkDrag } from '@angular/cdk/drag-drop'
import { CommonModule, DatePipe } from '@angular/common';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { InitService, ENV_CONFIG_UM, keyCloakInitializer, EnvService, AuthInterceptorService, ApiResponseInterceptor, ErrorInterceptor, Path, Config, AuthorizationModule } from 'usermgmt';
import { SidemenuComponent } from './componens/sidemenu/sidemenu.component';
import { HeaderComponent } from './componens/header/header.component';
import { SideMenuService } from './componens/sidemenu/sidemenu.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToolbarModule } from 'ngx-mobile-app';
import { SplashModule } from './modules/splash/splash.module';
import { GoogleLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { PrivacyPolicyModule } from './modules/privacy-policy/privacy-policy.module';
// import { ENV_CONFIG } from 'shared/lib/tokens/env.token';
import { environment } from '../environments/environment';


export function initializeSideBarConfig(initSrv: InitService) {
    return () => initSrv.loadConfig({
      path: Path.SIDEBAR_CONFIG_PATH,
      configType: Config.SIDEBAR_CONFIG
    });
  }
// MaterialModule
@NgModule({
    declarations: [
        AppComponent,
        SidemenuComponent,
        HeaderComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        DragDropModule,
        CdkDrag,
        AppRoutingModule,
        FormsModule,  
        ReactiveFormsModule,
        MaterialModule,
        HttpClientModule,
        ToastrModule.forRoot({
          preventDuplicates:true,
          closeButton:true
        }),
        NgxUiLoaderModule.forRoot(SpinnerConfig),
        MobileFirstModule,
        ProjectCoreModule,
        KeycloakAngularModule,
        AuthorizationModule,
        ToolbarModule,
        SplashModule,
        PrivacyPolicyModule,
        AppPermissionsPipe,
    ],
    providers:[
        VlHttpService,
        InitService,
        DatePipe,
        SideMenuService,
        NgbActiveModal,
        {
          provide: APP_INITIALIZER,
          useFactory: keyCloakInitializer,
          multi : true,
          deps : [Injector, KeycloakService, EnvService]
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptorService,
          multi: true
        },
        { provide: ENV_CONFIG, useValue: environment },
        { provide: ENV_CONFIG_UM, useValue: environment },
        {
          provide: HTTP_INTERCEPTORS,
          useClass : ApiResponseInterceptor,
          multi : true
        },
        {
          provide: APP_INITIALIZER,
          useFactory: initializeSideBarConfig,
          deps: [InitService],
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorInterceptor,
          multi: true
        },
        {
          provide: 'SocialAuthServiceConfig',
          useValue: {
            autoLogin: false, 
            providers: [
              {
                id: GoogleLoginProvider.PROVIDER_ID,
                provider: new GoogleLoginProvider('746677174864-7vms2hd8ol9g193j0ah2jp1e5qlka9na.apps.googleusercontent.com', 
                {
                  oneTapEnabled: false,
                  scopes: 'https://www.googleapis.com/auth/cloud-platform',
                
                })
              },
            ],
            onError: (err) => {
              console.error(err);
            },
          } as SocialAuthServiceConfig,
        }
    ]
})
export class AppModule {}
  
